<template>
  <div   id="main-work-proj"  v-if="loaded" :class="doneScreen">


    <!--
    <div id="nav-work-proj">

      <work-proj-module :lang="lang" :projId="item" v-for="(item, index) in projects" :scroll="scroll" :actScreen="actScreen" :totalScreen="totalScreen" :numScreen="(index + 1)">

      </work-proj-module>

    </div>
-->
    <div id="nav-work-proj" >

      <!--home-proj-module  v-for="(item, index) in projectsFinal" :lamg="lang" :projData="item"></home-proj-module-->

      <work-proj-module  v-for="(item, index) in projectsFinal" :lang="lang" :projData="item" :actScreen="actScreen" :myScreen="index" :scroll="scroll" :overMe="overMe"></work-proj-module>



    </div>


    <div class="nav-tags">
      <div class="nav-tags-item" v-for="(item, index) in tags" :class="{'active' : projectsFinal[actScreen].proj.tags[0].name[lang].name == item.name[lang].name}" v-on:click="getActiveTag(item.name[0].name)"  v-on:mouseover="controlDragTool(6)" v-on:mouseout="controlDragTool(2)">{{item.name[lang].name}}</div>
    </div>






    <div id="dragme" :class="{'ver' : dragToolMode == 1, 'hide' : dragToolMode == 6, 'inact' : dragToolMode == 2}">
      <span class="" v-if="dragToolMode == 0">  DRAG ME    </span>
      <span class="" v-if="dragToolMode == 1">  VER CASE    </span>


    </div>


  </div>





</template>

<script>



    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, WP, hasClicks, setClicks, setDeskProj} from '../../main';
    import WorkProjModule from "./WorkProjModule";


    export default {

        name: 'work-proj',
      components: {WorkProjModule},
      props: ['lang', 'doneScreen', 'tags', 'projects'],
      watch: {
          /*
        this.actScreen () {


          console.log(this.actScreen)
        }


           */

        },
        data() {
            return {

              detailMain: {},
              parallaxElements:[],
              pastPosX: 0,
              startPosX: 0,
              dragTargetX: 0,
              pastX: 0,
              scroll: 0,
              overMe: 0,
              actPos: 0,
              actScreen: 0,
              totalScreen: 0,
              visited: false,
              //tags: [],
              //projects: [],
              projectsFinal: [],
              loaded: false,
              dragToolMode : 2,
              hastouch: false,



            }
        },

        created() {


          setClicks();

          let obj = {
            total : this.projectsFinal.length,
            act: this.actScreen
          }


          setDeskProj(obj)

        },
        mounted() {

          /*
          this.detailMain = document.getElementById('nav-work-proj');
          this.main = document.getElementById('main-work-proj');
            EVENTBUS.$on('control-proj-work', this.control);

            //EVENTBUS.$emit('AAA', 0);
            //EVENTBUS.$emit('AAA', 0);
            //EVENTBUS.$emit('AAA', 0);


           */

          this.distributeProjects();

          EVENTBUS.$on('controlDragTool', this.controlDragTool);
          EVENTBUS.$on('getActiveTag', this.getActiveTag);
          EVENTBUS.$on('evtMasterNavigate', this.evtMasterNavigate);

          window.addEventListener('resize', this.resizeMe);

          this.resizeMe();
        },

        destroyed() {
          this.removeMe();
          window.removeEventListener('resize', this.resizeMe);
        },

        methods: {

          resizeMe(){
            let refW = (window.innerWidth * 0.14)  +  (window.innerWidth * 0.07);


            this.getScreen(this.actualScreen);
            $( this.detailMain).width((this.totalScreen * refW) + window.innerWidth)

          },


          distributeProjects(){

            const _this = this;

            let groups  = [];

            _this.tags.forEach(function(obj, index){
              let tagRef = obj.name[0].name;
              groups.push([]);

              _this.projects.forEach(function(proj, index2){
                let projRef = proj.tags[0].name[0].name;
                if(tagRef === projRef){
                  groups[index].push(_this.projects[index2]);
                }
              });
            });


            groups.forEach(function(obj, index){

                let refVal1 = obj[0].tags[0].name[0].name;
                obj.forEach(function(obj2, index){
                let refVal2 = obj[0].tags[0].name[0].name;

                if(refVal1 === refVal2) {
                  _this.projectsFinal.push({proj : obj2, total: obj.length, order: index});
                }

              });
            });


            _this.totalScreen = _this.projectsFinal.length;
            _this.loaded = true;


            setTimeout(function(){
              _this.detailMain = document.getElementById('nav-work-proj');
              _this.main = document.getElementById('main-work-proj');
              _this.init();
            }, 100);

           /// console.log(_this.projectsFinal);
          },

          getActiveTag(_tag){

          // console.log(_tag)

            let found = 9999;
            this.projectsFinal.forEach(function(proj, index){

              let projRef = proj.proj.tags[0].name[0].name;

              if(found === 9999 && projRef == _tag){
                found = index;
              }


            });
            //console.log(found)
            this.getScreen(found);
          },





            control(b){

              if(b){
                //this.init();
                if(!this.visited) {
                  this.visited =  true;
                 // EVENTBUS.$emit('animCase');
                }
              }else{
              //  this.removeMe();
              }


            },

            init() {

              const _this = this;

/*
              _this.detailMain.addEventListener( "mousedown",  _this.auxMouseDown, false );
              _this.detailMain.addEventListener( "touchstart",  _this.auxMouseDown, false );

              _this.detailMain.addEventListener( "mouseup",  _this.auxMouseUp, false );
              _this.detailMain.addEventListener( "mouseleave",  _this.auxMouseUp, false );
              _this.detailMain.addEventListener( "mouseenter",  _this.auxMouseUp, false );

              _this.detailMain.addEventListener( "touchend",  _this.auxMouseUp, false );

            //  $('main').css('cursor', 'grab');





              */
              _this.detailMain.addEventListener( "mousemove",  this.navigationDrag2, false );
              _this.detailMain.addEventListener( "touchmove",  this.touchDrag2, false );
              document.addEventListener('keydown', _this.evtKey, false);


              let refW = (window.innerWidth * 0.14)  +  (window.innerWidth * 0.07);


              $( _this.detailMain).width((_this.totalScreen * refW) + window.innerWidth)

            },

          removeMe(){
            const _this = this;


            /*
            _this.detailMain.removeEventListener( "mousedown",  _this.auxMouseDown, false );
            _this.detailMain.removeEventListener( "touchstart",  _this.auxMouseDown, false );

            _this.detailMain.removeEventListener( "mouseup",  _this.auxMouseUp, false );
            _this.detailMain.removeEventListener( "mouseleave",  _this.auxMouseUp, false );
            _this.detailMain.removeEventListener( "mouseenter",  _this.auxMouseUp, false );

            _this.detailMain.removeEventListener( "touchend",  _this.auxMouseUp, false );

            */

            _this.detailMain.removeEventListener( "mousemove",  this.navigationDrag2, false );
            _this.detailMain.removeEventListener( "touchmove",  this.touchDrag2, false );
            document.removeEventListener('keydown', _this.evtKey, false);
          //  $('main').css('cursor', 'default');
          },


          touchDrag2(e){
            this.navigationDrag2(e.touches[0]);

          },

          navigationDrag2(e) {



            var dec = 0

            if($(this.detailMain).offset().top > 0){
              dec = -60;
            }else{
              dec = 60
            }




           // console.log('-------')

            TweenMax.to( '#dragme', .3, { x:   e.clientX, y: e.clientY + Math.abs($(this.detailMain).offset().top) + dec, force3D: true, ease: Power2.easeOut} );

          },

          controlDragTool(n){

            if(this.hastouch){
            //  this.dragToolMode = n;
            }

            this.dragToolMode = n;

          },



          auxMouseDown(e){
            //console.log(e);




          //  this.dragToolMode = 0;
            //this.hastouc =  false;


            this.hastouch = true;
            if(e.clientX != undefined) {
              this.startPosX = e.clientX;
              this.pastPosX = e.clientX;
            }else{
              this.startPosX =  e.touches[0].clientX;
              this.pastPosX =  e.touches[0].clientX;
            }


         //   $('main').css('cursor', 'grabbing');

            this.detailMain.addEventListener( "mousemove",  this.navigationDrag, false );
            this.detailMain.addEventListener( "touchmove",  this.touchDrag, false );
            // this.animModel(0);

            this.overMe = 1;

          },

          evtKey(e){


            if(e.code == 'ArrowLeft'){

              this.evtMasterNavigate(0);

            }

            else if(e.code == 'ArrowRight'){
                this.evtMasterNavigate(1);
            }

            this.hastouch = true;




          },

          evtMasterNavigate(n){

            console.log('AAAAAAAAAAAAAAAA')

            if(n == 0){

              if(this.actScreen > 0 ){
                this.getScreen(this.actScreen - 1);
              }

            }

            else if(n == 1){

              if(this.actScreen < this.projectsFinal.length ){
                this.getScreen(this.actScreen + 1);
              }
            }

            let obj = {
              total : this.projectsFinal.length,
              act: this.actScreen
            }


            this.hastouch = true;




          },

          auxMouseUp(e){

            if(e.clientX != undefined) {
              this.startPosX = e.clientX;
            }else{
              this.startPosX =  e.changedTouches[0].clientX;
            }



            this.detailMain.removeEventListener( "mousemove",  this.navigationDrag, false );
            this.detailMain.removeEventListener( "touchmove",  this.touchDrag, false );

            //this.animModel(1);
            this.overMe = 0;
            this.getScreen();


          },

          touchDrag(e){
            this.navigationDrag(e.touches[0]);
            this.scroll = 1;
          },

          navigationDrag(e) {
            this.dragTargetX = this.actPos + (e.clientX - this.startPosX );
            this.startPosX = e.clientX;
            this.actPos = this.dragTargetX;
            this.moveContent(0.5);
            this.scroll = 1;
          },



          navigation(e) {




            this.actPos -= e.deltaY / 2;
            this.actPos -= e.deltaX / 2;
            this.moveContent(1);
          },
          navAnchors(n){
            this.actPos = n;
            this.moveContent(2);
          },




          moveContent(v) {
            const _this = this;



            if(_this.actPos >= 0)  _this.actPos = 0;






            if(_this.actPos <= (0 - (_this.detailMain.clientWidth - window.innerWidth))) _this.actPos = (0 - (_this.detailMain.clientWidth - window.innerWidth));




            TweenMax.to( _this.detailMain, 1, { x:  _this.actPos, force3D: true, ease: Power2.easeOut, onComplete:function() {
             //   console.log(_this.actPos)
                _this.scroll = 0;
                if(_this.overMe === 0){

                }

                //  _this.animModel(1);


               // _this.getScreen();

              }} );


            // TweenMax.to($('.content-detail'), 1, { x:100, force3D:true });

           // _this.objLine = {pos: _this.actPos, w: _this.detailMain.clientWidth, screen: window.innerWidth}
          //  EVENTBUS.$emit('set-objLine', _this.objLine);

            // this.doneScreen();


            //this.moveParallax();
          },

          getScreen(pos = 9999){


            let stopOver = [];
            let stopOverPos = [];
            let dif = [];

            let screenIndex = 0;

            let pageW = (window.innerWidth * 0.14) +  (window.innerWidth * 0.07);
            let activePageW = 0 //window.innerWidth * 0.44;

            let total = this.detailMain.clientWidth / pageW;

            if(total > this.projectsFinal.length) {
              total = this.projectsFinal.length;
            }

            for(let i = 0; i < total; i++){

              if(i <= 0) {
                stopOver.push(0)
                stopOverPos.push(0)
              }else{
                stopOver.push(0 - ((pageW * i) + activePageW));
                stopOverPos.push((pageW * i) + activePageW);
              }

            }

            for(let i = 0; i < total; i++){
              dif.push(Math.abs(stopOverPos[i]  + this.actPos) );
            }
           // console.log(dif);

            for(let i = 0; i < total; i++){
              if(Math.min.apply(Math, dif) == dif[i]){
              screenIndex = i;

              }
              //dif.push(Math.abs(stopOverPos[i]  + this.actPos) );
            }

           //&& console.log( this.startPosX + ' | ' + this.pastPosX)

            var _target =  this.startPosX - this.pastPosX;




            //console.log(stopOver[screenIndex])
            //console.log(pos)

            if(pos != 9999) {

              screenIndex = pos;
            }
            this.actScreen = screenIndex
            this.actPos = stopOver[screenIndex];

           // console.log(window.innerWidth)
           // console.log(screenIndex)


            let obj = {
              total : this.projectsFinal.length,
              act: this.actScreen
            }


            setDeskProj(obj)

            this.moveContent(1);

           // $('main').css('cursor', 'grab');
          },




        },
    };

</script>


// WEBPACK FOOTER //
// src/components/Modules/WorkProj.vue